import { render, staticRenderFns } from "./BrandSamplingLog.vue?vue&type=template&id=790e2d0e&scoped=true"
import script from "./BrandSamplingLog.vue?vue&type=script&lang=js"
export * from "./BrandSamplingLog.vue?vue&type=script&lang=js"
import style0 from "./BrandSamplingLog.vue?vue&type=style&index=0&id=790e2d0e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e2d0e",
  null
  
)

export default component.exports